import { $setBlocksType } from '@lexical/selection';
import { $createParagraphNode, $getSelection, $isRangeSelection } from 'lexical';
import { BlockPickerOption } from '../BlockPickerPlugin/BlockPickerOption';
import { c } from 'ttag';
export const ParagraphBlock = {
    name: c('B3.Notes.EditorToolbar.Label').t `Paragraph`,
    iconName: 'paragraph',
    keywords: ['normal', 'paragraph', 'p', 'text'],
    onSelect: (editor) => editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            $setBlocksType(selection, () => $createParagraphNode());
        }
    }),
};
export function GetParagraphBlockOption(editor) {
    return new BlockPickerOption(ParagraphBlock.name, {
        iconName: ParagraphBlock.iconName,
        keywords: ParagraphBlock.keywords,
        onSelect: () => ParagraphBlock.onSelect(editor),
    });
}
